<template>
  <div>
    <PageAllow
      controller="ReturnPurchases"
      :action="isNew ? 'add' : isView ? 'view' : mode"
    />
    <Breadcrumbs :items="items" />

    <!-- 仓库供应商 -->
    <v-dialog v-model="selectStockDialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("returnPurchase.create") }}
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 py-8">
          <v-container class="pb-8">
            <v-row
              class="pa-3"
              v-if="
                accountInfo &&
                accountInfo.version &&
                (accountInfo.version.stock_type == 2 ||
                  accountInfo.version.stock_type == 3)
              "
            >
              <span class="text-right subtitle-1">
                {{ $t("CRUD.chooseInfo", [$t("returnPurchaseDetail.stock")])
                }}{{ $t("Global.colon") }}
              </span>
              <SearcherStock
                v-model="stockSelected"
                noLabel
                single-line
                dense
                hide-details
                class="d-inline mt-0"
                :stock-types="[0]"
              />
            </v-row>
            <v-row class="pa-3 pt-6">
              <span class="text-right subtitle-1">
                {{ $t("CRUD.chooseInfo", [$t("returnPurchaseDetail.supplier")])
                }}{{ $t("Global.colon") }}
              </span>
              <SearcherSupplier
                v-model="supplierSelected"
                no-label
                single-line
                dense
                hide-details
                class="d-inline mt-0"
              />
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-sheet class="transparent-background-color py-4 mx-4">
      <v-expansion-panels v-model="panels" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{
                mode == "new"
                  ? $t("returnPurchase.create")
                  : $t("CRUD.info", [$t("returnPurchaseDetail.ObjectName")])
              }}
              <v-chip
                v-if="!isNew"
                small
                label
                class="ms-4 mt-1"
                :color="returnPurchase.status | returnPurchaseStatusColor"
                :text-color="returnPurchase.status | returnPurchaseStatusTextColor"
              >
                {{ returnPurchase.status | returnPurchaseStatusText }}
              </v-chip>
              <v-spacer />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
                <v-btn
                  v-if="preview"
                  small
                  dark
                  outlined
                  color="secondary"
                  class="px-2 me-2 mb-1 elevation-1"
                  @click.stop="
                    returnPurchase = JSON.parse(purchaseBeforPreview);
                    preview = false;
                  "
                >
                  <v-icon x-small class="pe-1">fa-times</v-icon>
                  {{ $t("CRUD.backForModify") }}
                </v-btn>
                <v-btn
                  v-if="
                    isNew && $permission.permissionAllow('ReturnPurchases', 'add')
                  "
                  small
                  :disabled="!stock || !stock.id"
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="preview ? doSubmit() : doPreview()"
                >
                  <v-icon x-small class="pe-1">fa-save</v-icon>
                  {{ $t("returnPurchaseDetail.actions.submit") }}
                </v-btn>
                <!-- 保存编辑 -->
                <v-btn
                  v-if="
                    mode == 'edit' &&
                    $permission.permissionAllow('ReturnPurchases', 'edit')
                  "
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="preview ? doSubmit() : doPreview()"
                >
                  <v-icon x-small class="pe-1">fa-save</v-icon>
                  {{ $t("returnPurchaseDetail.actions.editPurchaseSubmit") }}
                </v-btn>
                <v-btn
                  v-if="
                    mode == 'confirm' &&
                    $permission.permissionAllow('ReturnPurchases', 'confirm')
                  "
                  small
                  dark
                  color="action"
                  class="px-2 me-2 mb-1"
                  @click.stop="preview ? doSubmit() : doPreview()"
                >
                  <v-icon x-small class="pe-1">fa-location-arrow</v-icon>
                  {{ $t("returnPurchaseDetail.actions.confirmPurchaseSubmit") }}
                </v-btn>
              </v-sheet>
              <ReturnPurchasesActions
                v-if="isView"
                :purchase="returnPurchase"
                showPrint
                showExport
                :showConfirm="returnPurchase.actions && returnPurchase.actions.return_confirm"
                :showEdit="!$route.path.startsWith('/return-purchases-approve') && returnPurchase.actions && returnPurchase.actions.return_edit"
                :showCancel="returnPurchase.actions && returnPurchase.actions.return_cancel"
                :showApprove="$route.path.startsWith('/return-purchases-approve')"
                showCopy
                @done="getPurchasesDetailsFromAPI()"
              />
            </v-card-title>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-divider />
            <v-row no-gutters class="mt-4 table-style">
              <!-- 采购单号 -->
              <v-col cols="12" md="4" v-if="!isNew">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                     {{ $t("PurchasesList.Fields.purchase_code") }}{{ $t("Global.colon") }}
                  </span>
                  {{ returnPurchase.purchase_code }}
                </v-card>
              </v-col>
              <!-- 原采购单号 -->
              <v-col cols="12" md="4" v-if="!isNew && forStockInFlg">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("returnPurchaseDetail.Fields.purchase_code") }}{{ $t("Global.colon") }}
                  </span>
                  {{ returnPurchase.relation_purchase.purchase_code }}
                </v-card>
              </v-col>
              <!-- 原入库单号 -->
              <v-col cols="12" md="4" v-if="!isNew && forStockInFlg">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("returnPurchaseDetail.Fields.stock_in_code") }}{{ $t("Global.colon") }}
                  </span>
                  {{ returnPurchase.relation_stock_in_order.stock_order_code }}
                </v-card>
              </v-col>
              <!-- 创建时间 -->
              <v-col cols="12" md="4" v-if="!isNew">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("returnPurchaseDetail.Fields.created") }}{{ $t("Global.colon") }}
                  </span>
                  {{ returnPurchase.created | formatTime }}
                </v-card>
              </v-col>
              <!-- 实际退货时间 -->
              <v-col cols="12" md="4" v-if="!isNew">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("returnPurchaseDetail.Fields.hope_delivery_date") }}
                    <Required
                      :show="mode == 'edit' ? true : false"
                      :mode="mode == 'edit' ? 'new' : ''"
                    />
                    {{ $t("Global.colon") }}
                  </span>
                  <SearcherDatetime
                    v-if="mode == 'edit'"
                    class="my-n2"
                    v-model="returnPurchase.hope_delivery_date"
                    type="date"
                    single-line
                    dense
                    hide-details
                    :disabled-before-today="mode == 'edit'"
                  />
                  <span v-else>
                    {{ returnPurchase.hope_delivery_date | formatDate }}
                  </span>
                </v-card>
              </v-col>
              <!-- 原采购单号 -->
              <v-col cols="12" md="4" v-if="isNew">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("returnPurchaseDetail.Fields.purchase_code") }}{{ $t("Global.colon") }}
                  </span>
                  {{ forStockIn ? forStockIn.purchase_code : "" }}
                </v-card>
              </v-col>
              <v-col cols="12" md="8" v-if="isNew">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("returnPurchaseDetail.Fields.stock_in_code") }}{{ $t("Global.colon") }}
                  </span>
                  {{ forStockIn ? forStockIn.stock_order_code : "" }}
                  <v-btn
                      v-if="isNew && !preview"
                      small
                      dark
                      text
                      color="action"
                      class="mb-n2"
                      @click.stop="selectStockInDialog = true"
                  >
                    <v-icon x-small class="pe-1">fa-store</v-icon>
                    {{ $t("CRUD.rechooseInfo", [$t("returnPurchaseDetail.Fields.stock_in_code")]) }}
                  </v-btn>
                  <v-btn
                      v-if="forStockInFlg && !preview"
                      class="mt-1"
                      icon
                      x-small
                      text
                      @click.stop="forStockInFlg = false"
                  >
                    <v-icon x-small class="pe-1">fa-times</v-icon>
                  </v-btn>
                </v-card>
              </v-col>
<!--              &lt;!&ndash; 原采购入库单号 &ndash;&gt;-->
<!--              <v-col cols="12" md="8" v-if="isNew">-->
<!--                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>-->
<!--                  <span class="secondary&#45;&#45;text">-->
<!--                   {{ $t("returnPurchaseDetail.Fields.stock_in_code") }}{{ $t("Global.colon") }}-->
<!--                  </span>-->
<!--                  <span>-->
<!--                    {{ forStockIn ? forStockIn.stock_order_code : "" }}-->
<!--                  </span>-->
<!--                  <v-btn-->
<!--                    v-if="isNew && !preview && (stock && stock.id && supplier && supplier.id) && forStockInFlg"-->
<!--                    small-->
<!--                    dark-->
<!--                    text-->
<!--                    color="action"-->
<!--                    class="mb-n2"-->
<!--                    @click.stop="selectStockInDialog = true"-->
<!--                  >-->
<!--                    <v-icon x-small class="pe-1">fa-store</v-icon>-->
<!--                    {{ $t("CRUD.rechooseInfo", [$t("returnPurchaseDetail.Fields.stock_in_code")]) }}-->
<!--                  </v-btn>-->
<!--                  <v-btn-->
<!--                    v-if="forStockIn && !preview"-->
<!--                    class="mt-1"-->
<!--                    icon-->
<!--                    x-small-->
<!--                    text-->
<!--                    @click.stop="forStockInFlg = false"-->
<!--                  >-->
<!--                    <v-icon x-small class="pe-1">fa-times</v-icon>-->
<!--                  </v-btn>-->
<!--                </v-card>-->
<!--              </v-col>-->
              <!-- 仓库 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("returnPurchaseDetail.Fields.stock") }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="stock && stock.name && stock.name.length > 12" :title="stock.name" style="cursor: pointer">
                    {{ stock.name.slice(0, 12) + "......" }}
                  </span>
                  <span v-else>
                    {{ stock ? stock.name : "" }}
                  </span>
                  <v-btn
                    v-if="
                      isNew &&
                      !preview &&
                      accountInfo &&
                      accountInfo.version &&
                      (accountInfo.version.stock_type == 2 ||
                        accountInfo.version.stock_type == 3)
                    "
                    small
                    dark
                    text
                    color="action"
                    class="mb-n2"
                    @click.stop="selectStockDialog = true"
                  >
                    <v-icon x-small class="pe-1">fas fa-cubes</v-icon>
                    {{ $t("CRUD.rechooseInfo", [$t("returnPurchaseDetail.stock")]) }}
                  </v-btn>
                </v-card>
              </v-col>
              <!-- 供应商 -->
              <v-col
                cols="12"
                md="4"
                v-if="mode == 'new' || (savable && !isNew) || isView"
              >
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("returnPurchaseDetail.Fields.supplier_name") }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="supplier && supplier.supplier_name && supplier.supplier_name.length > 12" :title="supplier.supplier_name" style="cursor: pointer">
                    {{ supplier.supplier_name.slice(0, 12) + "......" }}
                  </span>
                  <span v-else>
                  {{ supplier ? supplier.supplier_name : "" }}
                  </span>
                  <v-btn
                    v-if="isNew && !preview"
                    small
                    dark
                    text
                    color="action"
                    class="mb-n2"
                    @click.stop="selectStockDialog = true"
                  >
                    <v-icon x-small class="pe-1">fas fa-house-user</v-icon>
                    {{
                      $t("CRUD.rechooseInfo", [$t("returnPurchaseDetail.supplier")])
                    }}
                  </v-btn>
                </v-card>
              </v-col>
              <!-- 实际退货时间 -->
              <v-col cols="12" md="4" v-if="isNew">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("returnPurchaseDetail.Fields.hope_delivery_date") }}
                    <Required
                      :show="savable ? true : false"
                      :mode="savable ? 'new' : ''"
                    />
                    {{ $t("Global.colon") }}
                  </span>
                  <SearcherDatetime
                    v-if="!preview"
                    class="my-n2"
                    v-model="returnPurchase.hope_delivery_date"
                    type="date"
                    single-line
                    dense
                    hide-details
                    removeIcon
                    :disabled-before-today="savable"
                  />
                  <span v-else>
                    {{ returnPurchase.hope_delivery_date | formatDate }}
                  </span>
                </v-card>
              </v-col>
<!--              &lt;!&ndash; 采购单来源 &ndash;&gt;-->
<!--              <v-col cols="12" md="4" v-if="isView || mode == 'confirm'">-->
<!--                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>-->
<!--                  <span class="secondary&#45;&#45;text">-->
<!--                    {{ $t("returnPurchaseDetail.Fields.origin_flg")-->
<!--                    }}{{ $t("Global.colon") }}-->
<!--                  </span>-->
<!--                  <span>-->
<!--                    {{ returnPurchase.origin_flg | originFlgsText }}-->
<!--                  </span>-->
<!--                </v-card>-->
<!--              </v-col>-->
              <!-- 创建者 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("returnPurchaseDetail.Fields.creater") }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ returnPurchase.creater_name }}
                  </span>
                </v-card>
              </v-col>
              <!-- 第三方单号 -->
              <v-col
                cols="12"
                :md="
                  mode == 'edit' || mode == 'new'
                    ? 8
                    : isView && returnPurchase.origin_flg == '102'
                    ? 4
                    : 4
                "
              >
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("returnPurchaseDetail.Fields.ext_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <v-text-field
                    v-if="savable && mode != 'confirm'"
                    v-model="returnPurchase.ext_code"
                    single-line
                    dense
                    hide-details
                    class="d-inline mt-0 mb-n1"
                  />
                  <span v-else>
                    {{ returnPurchase.ext_code }}
                  </span>
                </v-card>
              </v-col>
              <!-- 收货人 -->
              <v-col
                cols="12"
                md="4"
                v-if="settings && settings.show_purchase_address"
              >
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("returnPurchaseDetail.Fields.receiver_name")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{
                      returnPurchase.delivery_info
                        ? returnPurchase.delivery_info.receiver_name
                        : ""
                    }}
                  </span>
                </v-card>
              </v-col>
              <!-- 联系方式 -->
              <v-col
                cols="12"
                md="8"
                v-if="settings && settings.show_purchase_address"
              >
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("returnPurchaseDetail.Fields.receiver_phone")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{
                      returnPurchase.delivery_info
                        ? returnPurchase.delivery_info.receiver_phone
                        : ""
                    }}
                  </span>
                </v-card>
              </v-col>
              <!-- 收货地址 -->
              <v-col
                cols="12"
                md="12"
                v-if="settings && settings.show_purchase_address"
              >
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("returnPurchaseDetail.Fields.receiver_address")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{
                      returnPurchase.delivery_info
                        ? returnPurchase.delivery_info.receiver_province +
                          returnPurchase.delivery_info.receiver_city +
                          returnPurchase.delivery_info.receiver_area +
                          returnPurchase.delivery_info.receiver_address
                        : ""
                    }}
                  </span>
                </v-card>
              </v-col>
              <!-- 备注 -->
              <v-col cols="12" sm="12" md="12">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("returnPurchaseDetail.Fields.memo")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <v-text-field
                    v-if="savable"
                    v-model="returnPurchase.memo"
                    single-line
                    dense
                    hide-details
                    class="d-inline mt-0 mb-n1"
                  />
                  <span v-else>
                    {{ returnPurchase.memo }}
                  </span>
                </v-card>
              </v-col>
              <!-- 退货类型 -->
              <v-col cols="12" sm="12" md="12">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text pt-1">
                    {{ $t("returnPurchase.Fields.type") }}{{ $t("Global.colon") }}
                  </span>
                  <v-radio-group
                    row
                    v-model="returnType"
                    v-if="savable && !preview"
                    class="mt-0"
                    dense
                    hide-details
                  >
                    <v-radio
                      :label="$t('ReturnOrder.Type.on')"
                      :key="1"
                      :value="1"
                    />
                    <v-radio
                      :label="$t('ReturnOrder.Type.off')"
                      :key="2"
                      :value="2"
                    />
<!--                    <v-radio-->
<!--                      v-if="forStockInFlg"-->
<!--                      :label="$t('ReturnOrder.Type.both')"-->
<!--                      :key="3"-->
<!--                      :value="3"-->
<!--                    />-->
                  </v-radio-group>
                  <span v-else>
                    {{
                      returnType == 1
                          ? $t("ReturnOrder.Type.on")
                          : returnType == 2
                              ? $t("ReturnOrder.Type.off")
                              : returnType == 3
                                  ? $t("ReturnOrder.Type.both")
                                  : ""
                    }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-card
                  class="pa-2 d-flex overflow-auto text-no-wrap"
                  outlined
                  tile
                >
                  <span class="secondary--text">
                    {{ $t("returnPurchaseDetail.Fields.attachments") }}{{ $t("Global.colon") }}
                  </span>
                  <!-- 上传图片集 -->
                  <span class="ml-4">
                    <v-card
                      height="160"
                      width="240"
                      v-if="album && album.length > 0"
                    >
                      <v-carousel
                        hide-delimiters
                        cycle
                        height="160"
                        width="240"
                      >
                        <v-carousel-item
                          v-for="(item, i) in album"
                          :key="i"
                          :src="item"
                          @click.stop="$showFullscreenImages(album, i)"
                        >
                          <v-tooltip right v-if="savable && item">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                v-on="on"
                                color="secondary"
                                class="pa-2 float-right"
                                @click.stop="removeFromImages(i)"
                                v-if="isNew"
                              >
                                fa-times
                              </v-icon>
                            </template>
                            <span> {{ $t("Material.delImg") }}</span>
                          </v-tooltip>
                        </v-carousel-item>
                      </v-carousel>
                    </v-card>
                    <v-file-input
                      ref="imgs_file"
                      v-show="savable"
                      show-size
                      counter
                      small-chips
                      multiple
                      suffix
                      prepend-icon="fa-camera"
                      accept="image/png, image/jpeg"
                      persistent-hint
                      :placeholder="$t('Material.imgsPlaceholder')"
                      :hint="$t('Material.imgsHint')"
                      :rules="imgsRules"
                      v-model="imgs_file"
                    >
                    </v-file-input>
                  </span>
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- 活动记录 -->
        <v-expansion-panel v-if="!isNew" multiple accordio>
          <v-expansion-panel-header class="py-0">
            <v-tabs v-model="InfoTab" background-color="transparent">
              <v-tab
                @click.stop="
                  InfoTab = 0;
                  panels.indexOf(1) == -1 ? panels.push(1) : '';
                "
              >
                {{ $t("returnPurchaseDetail.activities.title") }}
              </v-tab>
              <v-tab
                @click.stop="
                  InfoTab = 1;
                  panels.indexOf(1) == -1 ? panels.push(1) : '';
                "
              >
                {{ $t("returnPurchaseDetail.activities.relations") }}
              </v-tab>
            </v-tabs>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tabs-items v-model="InfoTab">
              <!-- 活动记录 -->
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="activitiesHeaders"
                    :items="activities_details"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.created="{ item }">
                      {{ item.created | formatTime }}
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
              <!-- 相关单据 -->
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="relationsHeaders"
                    :items="purchaseRelations"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:header.actions="{ header }">
                      {{ header.text }}
                      <v-icon x-small>fa-sliders-h</v-icon>
                    </template>

                    <template v-slot:item.identify_name="{ item }">
                      <span v-if="!item.index" class="text-no-wrap">
                        {{ item.identify_name }}
                      </span>
                    </template>
                    <template v-slot:item.identify_code="{ item }">
                      <span class="text-no-wrap">
                        {{ item.identify_code }}
                      </span>
                    </template>
                    <template v-slot:item.status="{ item }">
                      <div v-if="item.status >= 0" class="text-no-wrap">
                        <v-chip
                            v-if="item.identify == 'purchases'"
                            small
                            label
                            :color="item.status | purchaseStatusColor"
                            :text-color="item.status | purchaseStatusTextColor"
                        >{{ item.status | purchaseStatusText }}
                        </v-chip>
                        <v-chip
                            v-if="item.identify == 'stock-orders-in'"
                            small
                            label
                            :color="item.status | stockOrderINStatusColor"
                            :text-color="item.status | stockOrderINStatusTextColor"
                        >{{ item.status | stockOrderINStatusText }}
                        </v-chip>
                        <v-chip
                            v-if="item.identify == 'stock-orders-out'"
                            small
                            label
                            :color="item.status | stockOrderOUTStatusColor"
                            :text-color="item.status | stockOrderOUTStatusTextColor"
                        >{{ item.status | stockOrderOUTStatusText }}
                        </v-chip>
                        <v-chip
                            v-if="item.identify == 'receipts'"
                            small
                            label
                            :color="item.pay_flg | billPayFlgsColor"
                            :text-color="item.pay_flg | billPayFlgsTextColor"
                        >{{ item.pay_flg | billPayFlgsText }}
                        </v-chip>
                        <v-chip
                            v-if="item.identify == 'receipts'"
                            small
                            label
                            class="ms-1"
                            :color="item.status | billStatusColor"
                            :text-color="item.status | billStatusTextColor"
                        >{{ item.status | billStatusText }}
                        </v-chip>
                      </div>
                    </template>
                    <template v-slot:item.created="{ item }">
                      <span class="text-no-wrap">
                        {{ item.created | formatTime }}
                      </span>
                    </template>
                    <template v-slot:item.creater_name="{ item }">
                      <span>
                        {{ item.creater_name }}
                      </span>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        v-if="$permission.permissionAllow(item.controller, 'view')"
                        small
                        outlined
                        color="info"
                        class="px-2 me-2"
                        :href="(item.identify != 'purchases') ? ('/#/' + item.identify + '/' + item.id) : ('/#/' + item.identify + '/detail/' + item.id)"
                      >
                        <v-icon x-small class="pe-1">fa-align-left</v-icon>
                        {{ $t("Opt.details") }}
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-card class="px-4 mt-4">
        <v-toolbar flat class="transparent-background-color">
          <v-row no-gutters align="center">
            <v-toolbar-title class="ms-n2">
              {{ $t("CRUD.details", [$t("returnPurchaseDetail.ObjectName")]) }}
            </v-toolbar-title>
            <v-spacer />
            <span
              v-if="savable && !preview"
              class="secondary--text text-subtitle-2 font-weight-bold"
            >
              {{ $t("returnPurchaseDetail.Fields.price_in_edit") }}{{ $t("Global.colon") }}
            </span>
            <span
              v-if="savable && !preview"
              class="accent--text text-subtitle-2 font-weight-bold"
            >
              {{ $t("Global.money") }}{{ price_fix | formatMoney }}
            </span>
            <!-- 选择商品 -->
            <v-btn
              color="primary"
              small
              dark
              class="px-2 me-2 mb-1 mx-1"
              v-if="forStockInFlg && isNew && !preview"
              @click="searchMaterialsDialog = true"
            >
              <v-icon x-small class="pe-1">fa-plus</v-icon>
              {{ $t("CRUD.chooseInfo", [$t("Material.ObjectName")]) }}
            </v-btn>
            <v-btn
              color="primary"
              small
              dark
              class="px-2 me-2 mb-1 mx-1"
              v-if="(!forStockInFlg &&  stock && stock.id && supplier && supplier.id) && isNew && !preview"
              @click="searchSupplierMaterialsDialog = true"
            >
              <v-icon x-small class="pe-1">fa-plus</v-icon>
              {{ $t("CRUD.chooseInfo", [$t("Material.ObjectName")]) }}
            </v-btn>
          </v-row>
        </v-toolbar>
        <v-divider />
        <ValidationObserver ref="observer">
          <!-- 采购退货单 -->
          <v-data-table
            id="purchase_details_table"
            :headers="detailHeaders"
            :items="purchase_details"
            :search="filter"
            multi-sort
            disable-pagination
            hide-default-footer
            :no-data-text="$t('Order.DetailNoData')"
            class="pb-2"
          >
            <template v-slot:top>
              <v-toolbar
                flat
                class="transparent-background-color"
                align-self="center"
              >
                <v-row no-gutters class="me-n3">
                <span class="caption secondary--text pt-2">
                  {{
                    $t(
                        "$vuetify.dataFooter.pageText",
                        purchase_details
                            ? [
                              purchase_details.length > 0 ? 1 : 0,
                              purchase_details.length,
                              purchase_details.length,
                            ]
                            : [0, 0, 0]
                    )
                  }}
                  </span>
                  <v-row no-gutters>
                    <v-spacer />
                    <v-col cols="12" sm="9" md="8">
                      <v-text-field
                        v-model="filter"
                        clearable
                        hide-details
                        :label="$t('Search.filter')"
                      />
                    </v-col>
                  </v-row>
                </v-row>
              </v-toolbar>
            </template>
            <template v-slot:body.prepend>
              <tr class="d-none d-sm-table-row">
                <td>
                  <span>{{ $t("TableSum") }}</span>
                </td>
                <td></td>
                <td></td>
<!--                <td v-if="forStockInFlg">-->
<!--                <span v-if="savable && !preview">-->
<!--                  <v-select-->
<!--                    v-model="returnTypeAll"-->
<!--                    single-line-->
<!--                    dense-->
<!--                    hide-details-->
<!--                    style="max-width: 140px; margin-right: auto; margin-left: auto"-->
<!--                    :items="[-->
<!--                      {text:$t('ReturnOrder.Type.on'), value:1},-->
<!--                      {text:$t('ReturnOrder.Type.off'), value:2},-->
<!--                    ]"-->
<!--                    item-text="text"-->
<!--                    item-value="value"-->
<!--                    clearable-->
<!--                  />-->
<!--                  </span>-->
<!--                </td>-->
                <td v-if="forStockInFlg && (isNew || isConfirm)"></td>
                <td align="right">
                  {{ quantity_total | formatTwoDot }}
                </td>
                <td align="right" v-if="!isNew">
                  {{ examine_num_total | formatTwoDot }}
                </td>
                <td></td>
                <td></td>
                <td
                  v-if="
                    settings &&
                    settings.lkl_sub_account_enable == 1 &&
                    settings.sub_account_modify_enable == 1 &&
                    forStockInFlg
                  "
                ></td>
                <td align="right">
                  {{ $t("Global.money") }}{{ price_fix | formatMoney }}
                </td>
                <td
                  colspan="2"
                  v-if="settings && settings.product_date_setting"
                ></td>
                <td></td>
                <td v-if="!isView && !preview"></td>
                <td v-if="!isNew && !preview"></td>
              </tr>
              <tr class="d-table-row d-sm-none">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("TableSum") }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row" v-if="!isNew">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("returnPurchaseDetail.Fields.quantity") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ quantity_total | formatTwoDot }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row" v-if="!isNew">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("returnPurchaseDetail.Fields.examine_num") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ examine_num_total | formatTwoDot }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("returnPurchaseDetail.Fields.sum") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money") }}{{ price_fix | formatMoney }}
                  </div>
                </td>
              </tr>
            </template>
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.Description="{ item }">
              <a
                class="text-no-wrap"
                :class="item.error_flg ? 'red--text' : ''"
                @click.stop="
                  dialogMaterialID = item.material_id
                "
              >
                <span>
                  {{item.material_name}}
                </span>
                <br />
                <span class="caption secondary--text">
                {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
                <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
                  {{ item.standard_name.slice(0, 12) + "......" }}
                </span>
                <span v-else>
                  {{ item.standard_name }}
                </span>
              </span>
              </a>
            </template>
            <template v-slot:item.return_type="{ item }">
              <v-select
                v-if="savable && !preview"
                v-model="item.return_type"
                single-line
                dense
                hide-details
                style="max-width: 140px; margin-right: auto; margin-left: auto"
                :items="[
                  {text:$t('ReturnOrder.Type.on'), value:1},
                  {text:$t('ReturnOrder.Type.off'), value:2},
                ]"
                item-text="text"
                item-value="value"
                @change="resetReturnType()"
              />
              <span v-else>
              {{
                  item.return_type == 1
                      ? $t("ReturnOrder.Type.on")
                      : item.return_type == 2
                          ? $t("ReturnOrder.Type.off")
                          : ""
                }}
              </span>
            </template>
            <template v-slot:item.quantity="{ item }">
              <ValidationProvider
                v-if="forStockInFlg"
                v-slot="{ errors }"
                :rules="{ max_value: { max: item.refundable_num } }"
              >
                <v-text-field
                  v-if="((isNew && item.new) || isEdit) && !preview"
                  single-line
                  dense
                  hide-details
                  v-model="item.quantity"
                  :error-messages="errors"
                  type="number"
                  min="0"
                  @blur="
                    item.quantity = $numberFormatter.formatWithDotNoMoreThan(
                      Number(item.quantity),
                      2
                    );
                    updateItemTotalPrice(item);
                  "
                  style="max-width: 100px; margin-left: auto"
                >
                </v-text-field>
                <span v-else>
                  {{ item.quantity | formatTwoDot }}
                </span>
              </ValidationProvider>
              <span v-else>
                <v-text-field
                  v-if="((isNew && item.new) || isEdit) && !preview"
                  single-line
                  dense
                  hide-details
                  v-model="item.quantity"
                  type="number"
                  min="0"
                  @blur="
                    item.quantity = $numberFormatter.formatWithDotNoMoreThan(
                      Number(item.quantity),
                      2
                    );
                    updateItemTotalPrice(item);
                  "
                  style="max-width: 100px; margin-left: auto"
                >
                </v-text-field>
                <span v-else>
                  {{ item.quantity | formatTwoDot }}
                </span>
              </span>
            </template>
            <template v-slot:item.examine_num="{ item }">
              <NumberInput
                v-if="(mode == 'confirm') && !preview"
                v-model="item.examine_num"
                dense
              />
              <span v-else>
              {{ item.examine_num | formatTwoDot }}
            </span>
            </template>
            <template v-slot:item.price="{ item }">
              <v-text-field
                v-if="savable && !preview && settings && settings.purchase_subtotal != 1"
                v-model="item.price"
                :placeholder="
                  $numberFormatter.formatTwoDot(item.org_price, 2) + ''
                "
                single-line
                dense
                hide-details
                type="number"
                min="0"
                :prefix="$t('Global.money')"
                  @blur="
                  item.price = $numberFormatter.formatWithDotNoMoreThan(
                    Number(item.price),
                    2
                  );
                  updateItemTotalPrice(item);
                "
                style="max-width: 80px; margin-left: auto"
              />
              <span v-else>
                {{ $t("Global.money") }}{{ item.price | formatMoneyFloor }}
              </span>
            </template>
            <template v-slot:item.total="{ item }">
              <v-text-field
                v-if="savable && !preview && settings && settings.purchase_subtotal == 1"
                v-model="item.total"
                :placeholder="
                  String($numberFormatter.formatTwoDot(item.total, 2))
                "
                single-line
                dense
                hide-details
                type="number"
                min="0"
                :prefix="$t('Global.money')"
                @blur="
                  item.total = $numberFormatter.formatWithDotNoMoreThan(
                    Number(item.total),
                    2
                  );
                  updateItemTotalPrice(item);
                "
                style="max-width: 80px; margin-left: auto"
              />
              <span v-else>
                {{ $t("Global.money") }}
                {{ item.total | formatMoney }}
              </span>
            </template>
            <template v-slot:item.production_date="{ item }">
              <SearcherDatetime
                v-if="savable && !preview"
                v-model="item.production_date"
                type="date"
                single-line
                dense
                hide-details
                hide-icon
                :required="
                  (item.material && Number(item.material.bestbefore) > 0) ||
                  settings.material_force_bestbefore == 1
                "
              />
              <span v-else>
                {{ item.production_date | formatDate }}
              </span>
            </template>
            <template v-slot:item.expired_date="{ item }">
              <SearcherDatetime
                v-if="savable && !preview"
                v-model="item.expired_date"
                type="date"
                single-line
                dense
                hide-details
                hide-icon
                :required="
                  (item.material && Number(item.material.bestbefore) > 0) ||
                  settings.material_force_bestbefore == 1
                "
              />
              <span v-else>
                {{ item.expired_date | formatDate }}
              </span>
            </template>
            <template v-slot:item.memo="{ item }">
              <v-text-field
                v-if="savable && !preview"
                v-model="item.memo"
                single-line
                dense
                hide-details
                style="max-width: 120px"
              >
                <template v-slot:append>
                  <v-icon
                    x-small
                    @click.stop="
                      detail_memo_item = item;
                      memoDialog = true;
                    "
                    class="pt-2 pb-1 primary--text"
                  >
                    fa-edit
                  </v-icon>
                </template>
              </v-text-field>
              <span v-else>
                {{ item.memo }}
              </span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                v-if="item.new"
                small
                text
                class="danger--text pa-0"
                @click.stop="
                  purchase_details.splice(
                    purchase_details.findIndex((detail) =>
                      item.id
                        ? item.id == detail.id
                        : item.material_id == detail.material_id
                      ),
                    1
                  )
                "
              >
                <v-icon>fa-times</v-icon>
              </v-btn>
            </template>
            <template v-slot:item.attachments="{ item }">
              <a
                v-if="item.img && item.img.length"
                class="text-no-wrap"
                @click.stop="
                  currentItem = item;
                  dialogAttachments = true;
                "
              >
                {{ $t("ReturnOrder.DetailFields.attachments") }}
              </a>
            </template>
          </v-data-table>
        </ValidationObserver>
      </v-card>
    </v-sheet>
    <!-- 备注弹窗 -->
    <v-dialog v-model="memoDialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          <span
            class="red--text d-inline-block text-truncate"
            style="max-width: 360px"
          >
            {{
              $t("Material.materialNameWithCode", [
                detail_memo_item.material_code,
                detail_memo_item.material_name,
              ])
            }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="memoDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 pt-8">
          <v-textarea
            v-model="detail_memo_item.memo"
            outlined
            :label="$t('Order.DetailFields.memo')"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="memoDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DialogStockIn
      v-model="selectStockInDialog"
      :stock="stock"
      :supplier="supplier"
      @confirm="selectStockIn = $event"
    />
    <MaterialDialog v-model="dialogMaterialID" />
    <ReturnMaterialsSelectsDialog
      v-model="searchMaterialsDialog"
      :returnMaterials="returnMaterials"
      :choosedItems="purchase_details"
      @confirm="selectMaterials($event)"
    />
    <ReturnSupplierMaterialsSelectsDialog
      v-model="searchSupplierMaterialsDialog"
      :stock="stock"
      :supplier="supplier"
      :choosedItems="purchase_details"
      @confirm="selectMaterials($event)"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import SearcherStock from "@/components/plugins/SearcherStock";
import SearcherSupplier from "@/components/plugins/SearcherSupplier";
import Required from "@/components/plugins/Required";
import NumberInput from "@/components/plugins/NumberInput.vue";
import MaterialDialog from "@/components/materials/plugins/Dialog.vue";
import DialogStockIn from "./plugins/DialogStockIn";
import ReturnMaterialsSelectsDialog from "./plugins/ReturnMaterialsSelectsDialog";
import ReturnSupplierMaterialsSelectsDialog from "./plugins/ReturnSupplierMaterialsSelectsDialog";
import ReturnPurchases from "@/api/return_purchases";
import Suppliers from "@/api/suppliers";
import Stocks from "@/api/stocks";
import Purchases from "@/api/purchases.js";
import Files from "@/api/files";
import ReturnPurchasesActions from "./plugins/Actions";

export default {
  components: {
    MaterialDialog,
    NumberInput,
    ValidationObserver,
    ValidationProvider,
    PageAllow,
    Breadcrumbs,
    ReturnPurchasesActions,
    SearcherSupplier,
    SearcherDatetime,
    SearcherStock,
    Required,
    DialogStockIn,
    ReturnMaterialsSelectsDialog,
    ReturnSupplierMaterialsSelectsDialog,
  },
  computed: {
    items() {
      let items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.returnPurchaseManagement"),
          disabled: false,
          href: "/return-purchases",
        },
        {
          text: i18n.t("Nav.returnPurchases"),
          disabled: false,
          href: "/return-purchases",
        },
        {
          text:
            this.mode == "confirm"
              ? i18n.t("Nav.returnPurchaseConfirm")
                : this.isNew
                  ? i18n.t("Nav.returnPurchaseNew")
                  : i18n.t("Nav.returnPurchaseDetail"),
          disabled: true,
        },
      ];
      if (this.returnPurchase && this.returnPurchase.purchase_code) {
        items.push({
          text: this.returnPurchase.purchase_code,
          disabled: false,
          accent: true,
        });
      }
      return items;
    },
    isNew() {
      return this.mode == "new";
    },
    isEdit() {
      return this.mode == "edit";
    },
    isConfirm() {
      return this.mode == "confirm";
    },
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return (
        !this.preview &&
        (this.mode == "new" ||
          this.mode == "edit" ||
          this.mode == "confirm")
      );
    },
    detailHeaders() {
      let headers = [
        {
          text: i18n.t("returnPurchaseDetail.Fields.category_name"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("returnPurchaseDetail.Fields.material_code"),
          align: "start",
          value: "material_code",
        },
        {
          text: i18n.t("returnPurchaseDetail.Fields.material"),
          align: "start",
          value: "Description",
        },
      ];
      // if (this.forStockInFlg) {
      //   headers.push({
      //     text: i18n.t("returnPurchaseDetail.Fields.return_type"),
      //     align: "center",
      //     value: "return_type"
      //   });
      // }
      if (this.forStockInFlg && (this.isNew || this.isConfirm)) {
        headers.push({
          text: i18n.t("returnPurchaseDetail.Fields.refundable_num"),
          align: "center",
          value: "refundable_num",
        });
      }
      headers.push({
        text: i18n.t("returnPurchaseDetail.Fields.quantity"),
        align: "end",
        value: "quantity",
      });
      if (!this.isNew) {
        headers.push({
          text: i18n.t("returnPurchaseDetail.Fields.examine_num"),
          align: "end",
          value: "examine_num",
        });
      }
      headers.push({
        text: i18n.t("returnPurchaseDetail.Fields.unit"),
        align: "center",
        value: "unit",
      });
      // if (this.forStockInFlg) {
      //   headers.push({
      //     text: i18n.t("returnPurchaseDetail.Fields.org_price"),
      //     align: "end",
      //     value: "org_price",
      //   });
      // }
      headers.push({
        text: i18n.t("returnPurchaseDetail.Fields.price"),
        align: "end",
        value: "price",
      });
      headers.push({
        text: i18n.t("returnPurchaseDetail.Fields.sum"),
        align: "end",
        value: "total",
      });
      if (this.settings && this.settings.product_date_setting) {
        headers.push({
          text: i18n.t("returnPurchaseDetail.Fields.production_date"),
          align: "start",
          value: "production_date",
          width: 136,
        });
        headers.push({
          text: i18n.t("returnPurchaseDetail.Fields.expired_date"),
          align: "start",
          value: "expired_date",
          width: 136,
        });
      }
      headers.push({
        text: i18n.t("returnPurchaseDetail.Fields.memo"),
        align: "start",
        sortable: false,
        value: "memo",
      });
      if (!this.isView && !this.preview)
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      if (!this.isNew && !this.preview)
        headers.push({
          text: i18n.t("ReturnOrder.Fields.attachments"),
          align: "start",
          sortable: false,
          value: "attachments",
        });
      return headers;
    },
    activitiesHeaders: () => [
      {
        text: i18n.t("returnPurchaseDetail.activities.created"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("returnPurchaseDetail.activities.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("returnPurchaseDetail.activities.operater"),
        align: "start",
        sortable: false,
        value: "operater.name",
      },
    ],
    relationsHeaders: () => [
      {
        text: i18n.t("ReturnOrder.RelationFields.identify_name"),
        align: "center",
        sortable: false,
        value: "identify_name",
      },
      {
        text: i18n.t("ReturnOrder.RelationFields.identify_code"),
        align: "start",
        sortable: false,
        value: "identify_code",
      },
      {
        text: i18n.t("ReturnOrder.RelationFields.status"),
        align: "center",
        sortable: false,
        value: "status",
      },
      {
        text: i18n.t("ReturnOrder.RelationFields.creater"),
        align: "start",
        sortable: false,
        value: "creater_name",
      },
      {
        text: i18n.t("ReturnOrder.RelationFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],

    ...mapState(["settings", "accountUser", "accountInfo"]),
  },

  data: () => ({
    stock: {},
    supplier: {},
    stockSelected: null,
    supplierSelected: null,
    selectStockDialog: false,
    selectStockInDialog: false,
    selectStockIn: null,
    forStockIn: [],
    forStockInFlg: false,
    returnType: 2,
    panels: [0],
    panelsDetail: [0],
    InfoTab: null,
    DetailTab: null,
    mode: "",
    returnMaterials: [],
    order_details: [],
    filter: "",
    returnTypeAll: 0,
    quantity_total: 0,
    examine_num_total: 0,
    dialogMaterialID: null,
    price_fix: 0,
    returnPurchase: {},
    purchase_details: [],
    activities_details: [],
    purchaseRelations: [],
    addMaterial: null,
    detail_memo_item: { memo: "" },
    memoDialog: false,
    purchasesPreview: [],
    preview: false,
    purchaseBeforPreview: null,
    stockMaterialsDialog: false,
    searchMaterialsDialog: false,
    searchSupplierMaterialsDialog: false,
    album: [],
    imgs_file: [],
    imgsRules: [
      (value) =>
        !value ||
        value.filter((v) => v.size >= 10000000).length == 0 ||
        i18n.t("Material.Import.imgsHint"),
    ],
  }),

  mounted() {
    if (this.$route.path.startsWith("/return-purchase-new")) {
      this.mode = "new";
    } else {
      this.mode = this.$route.params.mode;
      if (this.mode) {
        this.$router.replace("/return-purchases/" + this.$route.params.id);
      }
    }
  },

  methods: {
    getStockFromAPI(stock_id) {
      Stocks.fetchOne(stock_id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock = response.data.stock;
          }
        }.bind(this)
      );
    },
    selectMaterials(materials) {
      if (materials && materials.length) {
        materials.forEach((addMaterial) => {
          addMaterial.return_type = this.returnType

          // 计算小计金额
          if (this.settings.purchase_subtotal == 1) {
            if (addMaterial.quantity != 0) {
              addMaterial.price = Number(addMaterial.total) / Number(addMaterial.quantity);
            } else {
              addMaterial.price = 0;
            }
          } else {
            addMaterial.total = this.$numberFormatter.formatMoneyFloor(Number(addMaterial.quantity) * Number(addMaterial.price), 2);
          }
          this.purchase_details.push(addMaterial);
        });
      }
    },
    resetReturnType() {
      let onCount = 0
      let offCount = 0
      this.purchase_details.map(
          function (detail) {
            if (detail.return_type == 1){
              onCount++;
            }else {
              offCount++
            }
          }
      );
      this.returnType = (onCount == 0) ? 2 : (offCount == 0) ? 1 : 3
    },
    getPurchasesDetailsFromAPI() {
      ReturnPurchases.fetchOne(this.$route.params.id, {
        order_activity: 1
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.returnPurchase = response.data.return_purchase;
            this.returnPurchase.return_purchase_code = this.returnPurchase.purchase_code
            this.returnType = this.returnPurchase.return_type;
            if (this.returnPurchase.relation_purchase_stock_in_id) {
              this.forStockInFlg = true
              this.returnPurchase.purchase_id = this.returnPurchase.relation_purchase_id
              this.returnPurchase.purchase_stock_in_id = this.returnPurchase.relation_purchase_stock_in_id
            }
            this.purchase_details = response.data.return_purchase.purchase_details.map(
              (detail) => {
                detail.quantity = this.$numberFormatter.formatWithDotNoMoreThan(
                  Number(detail.quantity),
                  2
                );
                if (this.isConfirm) {
                  detail.examine_num = this.$numberFormatter.formatWithDotNoMoreThan(
                      Number(detail.quantity),
                      2
                  );
                }
                detail.price = this.$numberFormatter.formatWithDotNoMoreThan(
                    Number(detail.price),
                    2
                );

                if (this.settings && this.settings.purchase_subtotal != 1) {
                  detail.total = this.$numberFormatter.formatMoneyFloor(Number(detail.price) * Number(detail.quantity), 2)
                }

                return detail;
              }
            );
            this.stock = response.data.return_purchase.stock;
            this.supplier = response.data.return_purchase.supplier;
            this.album = response.data.return_purchase.img;
            this.activities_details = response.data.order_activities;
            if (this.$permission.permissionAllow("ReturnPurchases", "relations")) {
              ReturnPurchases.fetchRelations({
                purchase_code: this.returnPurchase.purchase_code,
                order_activity: 1,
              }).then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.purchaseRelations = [];
                      if (
                          response.data.purchase.length ||
                          Object.keys(response.data.purchase).length
                      ) {
                        this.purchaseRelations.push(
                            Object.assign(
                                {
                                  controller: "Purchases",
                                  identify: "purchases",
                                  identify_name: i18n.t("returnPurchaseDetail.relations.purchase"),
                                  identify_code: response.data.purchase.purchase_code,
                                },
                                response.data.purchase
                            )
                        );
                      }
                      if (
                          response.data.purchase_stock_in_order.length ||
                          Object.keys(response.data.purchase_stock_in_order).length
                      ) {
                        this.purchaseRelations.push(
                            Object.assign(
                                {
                                  controller: "StockIns",
                                  identify: "stock-orders-in",
                                  identify_name: i18n.t("returnPurchaseDetail.relations.stock_in"),
                                  identify_code: response.data.purchase_stock_in_order.stock_order_code,
                                },
                                response.data.purchase_stock_in_order
                            )
                        );
                      }
                      if (
                          response.data.stock_out_order.length ||
                          Object.keys(response.data.stock_out_order).length
                      ) {
                        this.purchaseRelations.push(
                            Object.assign(
                                {
                                  controller: "StockOuts",
                                  identify: "stock-orders-out",
                                  identify_name: i18n.t("returnPurchaseDetail.relations.stock_out"),
                                  identify_code: response.data.stock_out_order.stock_order_code,
                                },
                                response.data.stock_out_order
                            )
                        );
                      }
                      if (
                          response.data.bill.length ||
                          Object.keys(response.data.bill).length
                      ) {
                        this.purchaseRelations.push(
                            Object.assign(
                                {
                                  controller: "Receipt",
                                  identify: "receipts",
                                  identify_name: i18n.t("returnPurchaseDetail.relations.bill"),
                                  identify_code:
                                  response.data.bill.bill_code,
                                },
                                response.data.bill
                            )
                        );
                      }
                      if (
                          (response.data.finance_bill.length ||
                          Object.keys(response.data.finance_bill).length) &&
                          this.settings &&
                          this.settings.finance_bill_enable == 1
                      ) {
                        this.purchaseRelations.push(
                            Object.assign(
                                {
                                  controller: "FinanceBills",
                                  identify: "finance-bills-returnPurchase",
                                  identify_name: i18n.t("returnPurchaseDetail.relations.finance_bill"),
                                  identify_code:
                                  response.data.finance_bill.finance_bill_code,
                                },
                                response.data.finance_bill
                            )
                        );
                      }
                    }
                  }.bind(this)
              );
            }
          }
        }.bind(this)
      );
    },
    previewMethod() {
      this.returnPurchase = Object.assign({}, this.returnPurchase, {
        return_type: this.returnType,
      });
      if (this.isNew) return ReturnPurchases.addPreview(this.returnPurchase);
      else if (this.mode == "confirm")
        return ReturnPurchases.confirmPreview(this.returnPurchase);
      else if (this.mode == "edit") return ReturnPurchases.editPreview(this.returnPurchase);
    },
    async doPreview() {
      this.$store.dispatch("fullscreenLoading");
      this.purchaseBeforPreview = JSON.stringify(this.returnPurchase);
      // 检查一下图片上传的error，拒绝上传
      if (this.isNew) {
        if (this.$refs.imgs_file.hasError) {
          this.$store.dispatch("fullscreenLoadingStop");
          return;
        }
        //提交图片集
        let purchase_img = [];
        if (this.imgs_file && this.imgs_file.length > 0) {
          let response = await Files.imagesUpload(
              this.imgs_file,
              false,
              "images",
              true
          );

          if (response.data.status.isOK()) {
            response.data.data.forEach((img) => purchase_img.push(img.img_name));
          }
        }

        this.returnPurchase = Object.assign({}, this.returnPurchase, {
          img: purchase_img,
        });
      } else if (!this.isNew) {
        this.submitUploadImg();
      }
      this.previewMethod().then(
          function (response) {
            if (response.data.status.isOK()) {
              this.preview = true;
              this.returnPurchase = response.data.return_purchase;
              this.purchase_details = response.data.return_purchase.purchase_details.map(
                  (detail) => {
                    if (this.settings && this.settings.purchase_subtotal != 1) {
                      detail.total = this.$numberFormatter.formatMoneyFloor(Number(detail.price) * Number(detail.quantity), 2)
                    }
                    return detail;
                  }
              );
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
      );
    },
    submitMethod() {
      if (this.isNew) return ReturnPurchases.add(this.returnPurchase);
      else if (this.mode == "confirm") return ReturnPurchases.confirm(this.returnPurchase);
      else if (this.mode == "edit") return ReturnPurchases.edit(this.returnPurchase);
    },
    async doSubmit() {
      this.$store.dispatch("fullscreenLoading");
      this.$refs.observer.validate().then(
          async function (result) {
            if (result) {
              // 检查一下图片上传的error，拒绝上传
              if (this.isNew) {
                if (this.$refs.imgs_file.hasError) {
                  this.$store.dispatch("fullscreenLoadingStop");
                  return;
                }
                //提交图片集
                let purchase_img = [];
                if (this.imgs_file && this.imgs_file.length > 0) {
                  let response = await Files.imagesUpload(
                      this.imgs_file,
                      false,
                      "images",
                      true
                  );

                  if (response.data.status.isOK()) {
                    response.data.data.forEach((img) =>
                        purchase_img.push(img.img_name)
                    );
                  }
                }

                this.returnPurchase = Object.assign({}, this.returnPurchase, {
                  img: purchase_img,
                });
              } else if (!this.isNew) {
                this.submitUploadImg();
              }
              this.submitMethod().then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.$router.push("/return-purchases");
                      this.$store.commit("refreshToDos", true);
                    } else if (response.data.error.code == "ERR759") {
                      //退货单切单失败
                      this.mode = "view";
                    }
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
              );
            } else {
              this.$store.dispatch("fullscreenLoadingStop");
            }
          }.bind(this)
      );
    },
    removeFromImages(i) {
      this.album.splice(i, 1);
      this.imgs_file.splice(i, 1);
    },
    async submitUploadImg() {
      // 检查一下图片上传的error，拒绝上传
      if (this.$refs.imgs_file.hasError) {
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }

      //提交图片集
      let purchase_img = [];
      if (this.imgs_file && this.imgs_file.length > 0) {
        let response = await Files.imagesUpload(
          this.imgs_file,
          false,
          "images",
            true
        );

        if (response.data.status.isOK()) {
          response.data.data.forEach((img) => purchase_img.push(img.img_name));
          Purchases.update({
            purchase_code: this.returnPurchase.purchase_code,
            img: purchase_img,
          })
            .then(
              function () {
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            )
            .catch(
              function () {
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            );
        }
      }
    },
    updateItemTotalPrice(material) {
      // 计算小计金额
      if (this.settings.purchase_subtotal == 1) {
        if (material.quantity != 0) {
          material.price = Number(material.total) / Number(material.quantity);
        } else {
          material.price = 0;
        }
      } else {
        material.total = this.$numberFormatter.formatMoneyFloor(Number(material.quantity) * Number(material.price), 2);
      }
    },
  },

  watch: {
    $route(to, from) {
      this.selectStockDialog = false;
      if (to.path.startsWith("/return-purchase-new")) {
        this.mode = "new";
        this.panels = [0];
        this.panelsDetail = [0];
        this.album = [];
        this.InfoTab = null;
        this.DetailTab = null;
        this.stockSelected = null;
        this.supplierSelected = null;
        this.stock = {};
        this.supplier = {};
        this.addMaterial = null;
        this.returnPurchase = {
          hope_delivery_date: this.$datetimeUtils.formatTime(new Date()),
        }
        this.purchase_details = [];
      } else if (to.params.mode) {
        this.mode = to.params.mode;
        this.$router.replace("/return-purchases/" + to.params.id);
      } else if (
          from.path.startsWith("/return-purchase-new") &&
          from.path != to.path
      ) {
        this.mode = "view"; // 从return-order-new退回时触发状态变化和数据重加载
      }



      // else if (
      //     from.path.startsWith("/return-purchase-new") &&
      //     from.path != to.path
      // ) {
      //   this.mode = "view"; // 从return-purchase-new退回时触发状态变化和数据重加载
      // }
      // else if (to.params.mode) {
      //   this.mode = to.params.mode;
      //   this.$router.replace("/purchases/detail/" + to.params.id);
      // }
    },
    mode: {
      handler() {
        if (this.isNew) {
          this.returnPurchase = {
            created_id: this.accountUser ? this.accountUser.id : "",
            creater_name: this.accountUser ? this.accountUser.name : "",
            hope_delivery_date: this.$datetimeUtils.formatTime(
              new Date(new Date())
            ),
            purchase_details: [],
          };
        }
        else if (this.$route.params.id) {
          this.getPurchasesDetailsFromAPI();
        }
      },
    },
    supplierSelected: {
      deep: true,
      handler() {
        if (this.supplierSelected) {
          if (this.selectStockDialog) {
            if (this.stockSelected) {
              this.selectStockDialog = false;
            } else if (
                this.accountInfo &&
                this.accountInfo.version &&
                (this.accountInfo.version.stock_type == 1 ||
                    this.accountInfo.version.stock_type == 4)
            ) {
              //无仓版或极简版选完供应商后直接关闭弹窗
              this.selectStockDialog = false;
            }
          }
          if (this.forStockInFlg && this.forStockIn && this.forStockIn.supplier && this.forStockIn.supplier.id != this.supplierSelected.id) {
            this.forStockInFlg = false;
            this.forStockIn = [];
          }
          this.returnPurchase.supplier_id = this.supplierSelected.id;
          Suppliers.fetchOne(this.supplierSelected.id).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.supplier = response.data.supplier;
                  this.purchase = Object.assign({}, this.purchase, {
                    supplier_id: this.supplierSelected.id,
                  });
                }
              }.bind(this)
          );
        }
      },
    },
    stockSelected: {
      deep: true,
      handler() {
        if (this.stockSelected) {
          if (this.selectStockDialog && this.supplierSelected) {
            this.selectStockDialog = false;
          }
          if (this.forStockInFlg && this.forStockIn && this.forStockIn.stock && this.forStockIn.stock.id != this.stockSelected.id) {
            this.forStockInFlg = false;
            this.forStockIn = [];
          }
          this.getStockFromAPI(this.stockSelected.id);
        }
      },
    },
    selectStockIn: {
      immediate: true,
      handler() {
        if (this.selectStockIn) {
          this.purchase_details = [];
          this.returnMaterials = [];
          this.returnPurchase = Object.assign({}, this.returnPurchase, {
            purchase_id: this.selectStockIn.bill_purchase.id,
            purchase_stock_in_id: this.selectStockIn.id,
            purchase_details: this.purchase_details
          });
          this.forStockIn = JSON.parse(JSON.stringify(this.selectStockIn));
          this.forStockInFlg = true;
          if (this.forStockIn.stock) {
            this.stockSelected = JSON.parse(JSON.stringify(this.forStockIn.stock))
          }
          if (this.forStockIn.supplier) {
            this.supplierSelected = JSON.parse(JSON.stringify(this.forStockIn.supplier))
          }
          ReturnPurchases.getReturnableView(this.forStockIn.id).then(
              function (response) {
                if (response.data.status.isOK()) {
                  response.data.returnable_details.forEach((detail) => {
                    let purchase_detail = {
                      new: true,
                      category_code: detail.category_code,
                      category_name: detail.category_name,
                      material_id: detail.material_id,
                      material_code: detail.material_code,
                      material_name: detail.material_name,
                      standard_name: detail.standard_name,
                      price: this.$numberFormatter.formatMoneyFloor(detail.price),
                      total: detail.total,
                      unit: detail.unit,
                      standard_detail_id: detail.standard_detail_id,
                      production_date: detail.production_date,
                      expired_date: detail.expired_date,
                      material: detail,
                      refundable_num: detail.refundable_num,
                      quantity: detail.refundable_num,
                    };
                    this.returnMaterials.push(purchase_detail);
                  });
                }
              }.bind(this)
          )
          this.selectStockInDialog = false;
          this.selectStockIn = null;
        }
      },
    },
    forStockInFlg: {
      handler() {
        this.purchase_details = [];
        if (!this.forStockInFlg) {
          this.selectStockIn = null;
          this.forStockIn = [];
          delete this.returnPurchase.purchase_id;
          delete this.returnPurchase.return_purchase_code;
          delete this.returnPurchase.purchase_stock_in_id;
          this.returnPurchase.purchase_details = [];
        }
      },
    },
    returnPurchase: {
      deep: true,
      handler() {
        this.purchase_details = this.returnPurchase && this.returnPurchase.purchase_details ? this.returnPurchase.purchase_details : [];
        this.price_fix = this.returnPurchase ? this.returnPurchase.price_fix : 0;
      },
    },
    purchase_details: {
      deep: true,
      handler() {
        let priceFix = 0;
        let quantity_total = 0;
        let examine_num_total = 0;
        this.purchase_details.forEach((detail) => {
          let quantity = detail.quantity ? detail.quantity : 0;
          let examine_num = detail.examine_num ? detail.examine_num : 0;
          quantity_total += Number(quantity);
          examine_num_total += Number(examine_num);
          // detail.sum = parseFloat(
          //     this.$numberFormatter.formatMoneyFloor(
          //         parseFloat((detail.price * Number(quantity)).toFixed(4))
          //     )
          // );
          priceFix += Number(detail.total);
          //计算过期日期
          if (
              this.settings &&
              this.settings.product_date_setting &&
              detail.production_date &&
              !detail.expired_date
          ) {
            detail.expired_date = new Date(
                new Date(detail.production_date).getTime() +
                Number(detail.material.bestbefore) * 24 * 3600 * 1000
            )
                .toISOString()
                .substr(0, 10);
          }
        });
        priceFix = parseFloat(priceFix).toFixed(2);
        this.returnPurchase.price_fix = this.price_fix = priceFix;
        this.quantity_total = quantity_total;
        this.examine_num_total = examine_num_total;
      },
    },
    returnTypeAll: {
      handler() {
        if (this.returnTypeAll == 1 || this.returnTypeAll == 2) {
          this.returnType = this.returnTypeAll
          this.purchase_details = this.purchase_details.map(
              function (detail) {
                detail.return_type = this.returnTypeAll;
                return detail;
              }.bind(this)
          );
        }
      }
    },
    stock: {
      handler() {
        if (this.stock) {
          this.returnPurchase = Object.assign({}, this.returnPurchase, {
            stock_id: this.stock.id,
          });
          // todo
          // if (this.$route.query.material_ids) {
          //   var material_ids = decodeURI(this.$route.query.material_ids).split(
          //     ","
          //   );
          //   this.addFromMaterialsDetail(material_ids);
          // }
        }
      },
    },
    imgs_file: {
      deep: true,
      handler() {
        if (this.imgs_file.length) {
          if (this.imgs_file.length > 3) {
            this.$snackbar.error(i18n.t("Examine.DetailFields.hint"));
            this.album = [];
            this.imgs_file = [];
          } else {
            this.album = [];
            this.imgs_file.forEach((img) => {
              var reader = new FileReader();
              reader.readAsDataURL(img);
              let that = this;
              reader.onload = function () {
                that.album.push(this.result);
              };
            });
          }
        } else {
          this.album = this.returnPurchase.img ? this.returnPurchase.img : [];
        }
      },
    },
  },
};
</script>